import { Route, Routes } from "react-router-dom"
import Home from "./Components/Home"
import App from "./App"
import Explore from "./Components/Explore"
import View from "./Components/View"
import Signup from "./Components/Signup"
import Login from "./Components/Login"
import Srchview from "./Components/Srchview"
import Bookmarks from "./Components/Bookmarks"
const AppRoutes = () =>{
    return(
        <>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/explore" element={<Explore/>} />
            <Route path="/explore/:view" element={<View/>} />
            <Route path="/view" element={<View/>} />
            <Route path="/signup" element={<Signup/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/search" element={<Srchview/>} />
            <Route path="/book" element={<Bookmarks/>} />
        </Routes>
        </>
    )
}

export default AppRoutes;